module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_data01-2996485a066abfa0248396aee9b496d5.png";